export const PRODUCT_NAME = 'ABX CRM REACT'

export const SESSION_SAMPLED_KEY = 'isSessionSampled'
